import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AsideBarService } from "src/modules/base/services/asideBar.service";
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'app-aside-bar-tabs',
    templateUrl: './aside-bar-tabs.component.html',
    styleUrls: ['./aside-bar-tabs.component.scss'],
    standalone: false
})
export class AsideBarTabsComponent implements OnInit {
  @Input() casesheet_data:any;
  @Output() clickTab: EventEmitter<any> = new EventEmitter();
  currentConfig: any = {}; 
  
  constructor(
    public commonService: AsideBarService,
    public utilService: UtilService
  ) { }

  ngOnInit(): void {
    if(document.getElementById('aside-modal-container')){
      document.getElementById('aside-modal-container').classList.add('_aside-footer-tabs');
    }
    setTimeout(()=>{
      let doc = document.getElementById('bar-right');
      if(doc != null)
        this.commonService.expandButton = doc.clientHeight < doc.scrollHeight;
    })
  }

  ngAfterViewInit() {
    let form_class = document.getElementById('aside-modal-container');
    if(form_class){
      let a = document.getElementsByClassName('aside_ui_engine');
      if(a && a.length > 0){
        a[0]['style'].height = "calc(100% - 190px) !important";
      }
      if(document.getElementById('footer-tab-style'))
        document.getElementById('footer-tab-style').remove();
    }
  }

  tabClicked(cases){
    this.clickTab.emit(cases);
  }

  setExpandClasses(){
    this.commonService.expandButton = false;
    let doc = document.getElementById('bar-right');
    let h =  doc.scrollHeight - doc.clientHeight;
    doc.style.height = doc.scrollHeight.toString() + 'px';
    let sticky = document.getElementsByClassName('sticky-add-btn');
    if(sticky && sticky.length > 0){
      sticky[0]['style'].bottom = doc.style.height;
    }
    let form_class = document.getElementsByClassName('aside_ui_engine');
    if(form_class && form_class.length > 0){
      // replace rather than stack: collapse only removes one #footer-tab-style
      document.querySelectorAll('#footer-tab-style').forEach(old => old.remove());
      let styleElement = document.createElement('style');
      styleElement.id = "footer-tab-style";
      styleElement.textContent = "app-aside.aside-menu._aside-footer-tabs div.aside_ui_engine { height: calc(100% - "+(h+190)+"px) !important;}";
      document.querySelector('body').appendChild(styleElement);
    }
  }

  setCollapseClasses(){
    this.commonService.expandButton = true;
    let doc = document.getElementById('bar-right');
    doc.style.height = '70px';
    let sticky = document.getElementsByClassName('sticky-add-btn');
    let form_class;
    if(sticky && sticky.length > 0){
      sticky[0]['style'].bottom = '80px';
    }
    if(document.getElementById('footer-tab-style')){
      document.getElementById('footer-tab-style').remove();
    }
    if(document.getElementById('aside_ui_engine')){
      form_class = document.getElementsByClassName('aside_ui_engine');
    }
    if(form_class && form_class.length > 0){
      form_class[0]['style'].height = "calc(100% - 190px) !important";
    }
  }

  showExpandedTab(){
    this.currentConfig.expanded = true;
  }

  showCollapsedTab(){
    this.currentConfig.expanded = false;
  }
}

